export default __webpack_public_path__ + "static/media/Sarabun-Bold.bf525c98.ttf";